<template>
  <div class="text-center mt-2">
    <h3>
      {{ $t("pre_regis_add_subject.credits_that_student_can_take") }} :
      {{ min_credit }} - {{ max_credit }}
      <span
        v-if="!min_credit && !max_credit"
        class="text2"
        >{{ $t("pre_regis_add_subject.please_contact_officer") }}</span
      >
    </h3>
    <h3
      :class="
        summary_credit >= min_credit && summary_credit <= max_credit
          ? 'green--text mt-2'
          : 'red--text mt-2'
      "
    >
      {{ $t("pre_regis_add_subject.all_registered_credits") }} :
      {{ summary_credit }}
    </h3>
    <div v-if="is_acl_authorized_officer">
      <p
        v-if="summary_credit < min_credit"
        class="red--text mt-8"
        style="font-size: 50px; font-weight: bold"
      >
        หน่วยกิตรวมต่ำกว่าที่กำหนด ตรวจเช็คอีกที
      </p>
      <p
        v-else-if="summary_credit > max_credit"
        class="red--text mt-8"
        style="font-size: 50px; font-weight: bold"
      >
        หน่วยกิตรวมเกินกว่าที่กำหนด ตรวจเช็คอีกที
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreditBox",
  props: {
    summary_credit: Number,
    max_credit: Number,
    min_credit: Number,
  },
  computed: {
    is_acl_authorized_officer() {
      return this.$store.state.user.is_authorized_officer;
    },
  }
};
</script>

<style>
.text2 {
  background-color: red;
  border: 5px;
  color: white;
  padding-left: 3px;
  padding-right: 2px;
}
</style>
